import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const EmailVerificationRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Extract hash from query parameters
    const hash = searchParams.get('hash');
    const expires = searchParams.get('expires');
    const signature = searchParams.get('signature');
    
    console.log('Redirect component loaded');
    console.log('Hash:', hash);
    console.log('Expires:', expires);
    console.log('Signature:', signature);
    
    if (hash) {
      console.log('Redirecting to:', `/verify-email/${hash}`);
      // Redirect to proper verification route
      navigate(`/verify-email/${hash}`, { replace: true });
    } else {
      console.log('No hash found, redirecting to home');
      // No hash found, redirect to home
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div style={{
        background: 'white',
        padding: '40px',
        borderRadius: '20px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <i className="fas fa-spinner fa-spin" style={{fontSize: '3rem', color: '#667eea', marginBottom: '20px'}}></i>
        <p style={{marginTop: '20px', fontSize: '1.2rem', color: '#64748b'}}>
          Redirecting to verification page...
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationRedirect;
